<template>
  <div class="main">
    <span class="main-config">
    <div class="op" v-if="!readOnly">
      <label>{{ $t('operacoes') }} </label>
      <b-form-select
        class="input-pentagro"
        v-model="operationSelected"
        :options="operations"
      ></b-form-select>
    </div>
    <div v-if="!readOnly && operationSelected" class="op">
      <label>{{ $t('selecao-de-massa-a-ou-b') }} </label>
      <b-form-select
        class="input-pentagro"
        v-model="selectedMass"
        :options="selectionOptionsMass"
      ></b-form-select>
    </div>
    <div class="op" v-if="selectedMass == 'A' && operationSelected && !readOnly">
      <b-card class="cardMass"> {{ $t('massa-selecionada-a') }} </b-card>
    </div>
    <div class="op" v-if="selectedMass == 'B' && operationSelected && !readOnly">
      <b-card class="cardMass"> {{ $t('massa-selecionada-b') }} </b-card>
    </div>
    <b-form v-if="operationSelected" class="b-layout" @submit.prevent="">
      <b-card v-if="selectedMass == 'A' || selectedMass == 'B'">
        <div v-for="(prop, index) in equipments" :key="prop.caption + index">
          <b-form-checkbox
              class="switch-item"
              v-model="prop.value"
              @change="ChangeOnOff($event, prop)"
              switch
              >
              {{ prop.equipName }}
          </b-form-checkbox>
        </div>
      </b-card>
      <div class="ml-3" v-if="selectedMass == 'B'">
        <b-card>
          <div class="inp">
            <label>{{ $t('brix-do-magma') }} </label>
            <input
              v-model="brixAcucar.value"
              step="0.1"
              min="0"
              max="100"
              type="number"
            />
          </div>
          <div class="inp">
            <label>{{ $t('pureza-do-magma') }} </label>
            <input
              v-model="purAcucar.value"
              step="0.1"
              min="0"
              max="100"
              type="number"
            />
          </div>
          <div class="inp">
            <label>{{ $t('recup-da-sacarose-0') }} </label>
            <input
              v-model="K.value"
              step="0.1"
              min="0"
              max="100"
              type="number"
            />
          </div>
          <div class="inp">
            <label>{{ $t('brix-do-mel-final') }} </label>
            <input
              v-model="brixMel.value"
              step="0.1"
              min="0"
              max="100"
              type="number"
            />
          </div>
          <div class="inp">
            <label>{{ $t('pureza-do-mel') }} </label>
            <label>{{ purMel.value | ParseNumber }}</label>
          </div>
          <div class="inp">
            <label>{{ $t('capacidade-instalada-ton-h') }} </label>
            <label>{{ Capacidade.value | ParseNumber }}</label>
          </div>
          <div class="inp">
            <label>{{ $t('taxa-de-utilizacao') }} </label>
            <label>{{ Ocupacao.value | ParseNumber }}</label>
          </div>
        </b-card>
      </div>
      <div class="ml-3" v-if="selectedMass == 'A'">
        <b-card>
          <div class="inp">
            <label>{{ $t('brix-do-acucar') }} </label>
            <input
              v-model="brixAcucar.value"
              step="0.1"
              min="0"
              max="100"
              type="number"
            />
          </div>
          <div class="inp">
            <label>{{ $t('pureza-do-acucar') }} </label>
            <input
              v-model="purAcucar.value"
              step="0.1"
              min="0"
              max="100"
              type="number"
            />
          </div>
          <div class="inp">
            <label>{{ $t('recup-da-sacarose-0') }} </label>
            <input
              v-model="K.value"
              step="0.1"
              min="0"
              max="100"
              type="number"
            />
          </div>
          <div class="inp">
            <label>{{ $t('brix-do-mel-a') }} </label>
            <input
              v-model="brixMel.value"
              step="0.1"
              min="0"
              max="100"
              type="number"
            />
          </div>
          <div class="inp">
            <label>{{ $t('capacidade-instalada-ton-h') }} </label>
            <label>{{ Capacidade.value | ParseNumber }}</label>
          </div>
          <div class="inp">
            <label>{{ $t('taxa-de-utilizacao') }} </label>
            <label>{{ Ocupacao.value | ParseNumber }}</label>
          </div>
        </b-card>
      </div>
      
    </b-form>
    </span>
    <div v-if="jokerEquipmentList.length" class="joker">
      <label class="mt-2">{{ $t('equipamentos-coringas') }}</label>
      <div v-for="(joker, i) in jokerEquipmentList" :key="i">
        <b-form>
          <div class="ml-2 mr-2 mb-2">
            <TextToInput 
              :text="joker.caption"
              @sendText="updateCaption($event, joker)">
            </TextToInput>
          </div>
          <span class="b-layout">
            <b-card v-if="equipments.length > 0">
              <div v-for="(prop, index) in joker.equipments" :key="prop.caption + index">
                <b-form-checkbox
                  class="switch-item"
                  v-model="prop.value"
                  @change="ChangeOnOffJoker($event, prop, equipments, joker)"
                  switch
                  >
                  {{ prop.equipName }}
                </b-form-checkbox>
              </div>
            </b-card>
            <div class="ml-3" v-if="equipments.length > 0">
              <b-card>
                <div class="inp mb-2">
                  <label>{{ $t('capacidade-instalada-ton-h') }} </label>
                  <label class="input-data" >{{ joker.capacidade.value | ParseNumber }}</label>
                </div>
                <div class="inp">
                  <label>{{ $t('ocupacao-0') }} </label>
                  <label class="input-data">{{ joker.Ocupacao.value | ParseNumber }}</label>
                </div>
              </b-card>
            </div>
          </span>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { ParseToNumber } from "../../utils/tools";
import { JokerEquipmentMixin } from "../../../mixins/jokerEquipmentsMixin";
import TextToInput from "../../../template/TextToInput";
import { FiltersMixin } from '../../../mixins/filtersMixin';
import { SingletonInter } from '../_service/singletonInter';

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly:{
      type: Boolean,
      default: false,
    }
  },

  components: { TextToInput },

  mixins: [JokerEquipmentMixin, FiltersMixin],

  data() {
    return {
      selectionOptionsMass: [
        { value: null, text:SingletonInter.$t('selececione-massa-a-ou-b') },
        { value: "A", text:SingletonInter.$t('massa-a') },
        { value: "B", text:SingletonInter.$t('massa-b') },
      ],
      brixAcucar: {},
      purAcucar: {},
      Capacidade: {},
      brixMel: {},
      K: null,
      Ocupacao: null,
      purMel: null,
      selectedMass: null,
      operationSelected: null,
      attrList: [
        "brixAcucar",
        "purAcucar",
        "K",
        "brixMel",
        "Ocupacao",
        "purMel",
        "Capacidade"
      ],
      operations: [{ value: null, text:SingletonInter.$t('selecione-uma-operacao') }],
      operationAttributeList: [],
      firstLoad: false,
      equipments: [],
      equipCap: [],
    };
  },

  watch: {
    operationSelected(value) {
      if (this.firstLoad || !value) {
        this.firstLoad = false;
        return;
      }

      this.buildJokerEquipment(value, this.node.jokerCaption);
      
      this.operationAttributeList =
      SingletonEnginnering.getOperationsProperties(
          this.operationSelected
          ).filter((operation) => this.attrList.includes(operation.key));
          
          this.attrList.forEach((attrName) => {
            this[attrName] = this.operationAttributeList.find(
              (p) => attrName == p.caption
              );
              
              if (this[attrName])
              this[attrName].value = ParseToNumber(this[attrName].value);
          });
      this.loadEquipments();
      this.updateNode();
    },

    "brixAcucar.value"() {
      this.updateNode();
    },

    "purAcucar.value"() {
      this.updateNode();
    },

    "K.value"() {
      this.updateNode();
    },

    "brixMel.value"() {
      this.updateNode();
    },

    "Capacidade.value"(){
      this.updateNode();
    },

    selectedMass() {
      this.updateNode();
    },
  },

  methods: {
    loadNode() {
      if (this.node.data[0].index) {
        this.firstLoad = true;
        this.operationSelected = this.node.data[0].index;
        this.loadNotInput();
        this.buildJokerEquipment(
          this.node.data[0].index,
          this.node.jokerCaption
        );
      }

      this.selectedMass = this.node.selectedMass;
      this.equipments = new Array();

      this.node.data.forEach((p) => {
        if (this.attrList.includes(p.caption)) {
          p.value = ParseToNumber(p.value);
          this[p.caption] = p;
        }

        if (p.equipName) {
          let result = ParseToNumber(p.value) ? true : false;
          p.value = result;
          this.equipments.push(p);
        }
      });
      this.loadEquipments();
    },

    loadNotInput() {
      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));
      let attrNotInput = this.attrList.slice(2);

      attrNotInput.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.caption
        );

        if (this[attrName])
          this[attrName].value = ParseToNumber(this[attrName].value);
      });
    },

    loadEquipments() {
      let equipsName = SingletonEnginnering.getOperationsEquipments(
        this.operationSelected
      );
      let propsByEquipment = SingletonEnginnering.getEquipamentsProperties(
        this.operationSelected
      );
      let auxEquipment = new Array();

      equipsName.forEach((e) => {
        let props = propsByEquipment[e];
        Object.keys(props).forEach((p) => {
          if (props[p].caption == "Quantidade") {
            props[p].value = parseInt(props[p].value) ? true : false;
            auxEquipment.push(props[p]);
          }
          if (props[p].caption == "Capacidade") {
            this.equipCap.push(props[p]);
          }
        });
      });

      this.equipments = auxEquipment;
      this.ChangeCapacidade();
    },

    updateNode() {
      let attrs = [
        this.brixAcucar.clone(),
        this.purAcucar.clone(),
        this.K.clone(),
        this.brixMel.clone()
      ];

      this.equipments.forEach((e) => {
        let prop = e.clone();
        prop.value = e.value ? '1,00' : '0,00';
        attrs.push(prop);
      });
      this.node.attrs = attrs;

      this.node.selectedMass = this.selectedMass;
      this.updateJokerNode(this.node, this.jokerEquipmentList);
    },

    updateCaption(caption, joker){
      joker.caption = caption
      this.updateNode();
    },

    ChangeCapacidade() {
      if (this.Capacidade) {
        this.Capacidade.value = 0;
        this.equipments.forEach((e) => {
          let cap = this.equipCap.find((c) => c.equipName == e.equipName);
          let isTrue = JSON.parse(e.value);
          if (isTrue && cap) {
            this.Capacidade.value += parseFloat(
              String(cap.value).replace(",", ".")
            );
          }
        });
      }
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) => o.match(/SCF/));
      
      this.operations.splice(1);
      
      opList.forEach(op => { 
        let equipProp = SingletonEnginnering.getEquipamentsProperties(op);

        for (var eq in equipProp) {
          if(equipProp[eq][5].strValue == "C") {
            this.operations.push({ value: op, text: op })
            break;
          }
        }
      });
    },

    ChangeOnOff(event, prop) {
      prop.value = event;
      this.ChangeCapacidade();
      this.switchStatusJoker(prop, this.equipments, false, this.Changecapacidade)
      this.updateNode();
    },
  },

  mounted() {
    this.loadOperation();
    this.loadNode();
    this.ChangeCapacidade();
    this.changeExternalCapacity = function () {
      this.ChangeCapacidade();
    };
    this.updataNodeInMixin = function () {
      this.updateNode();
    };
  },
};
</script>

<style scoped>
.main{
  display: flex;
}

.main-config{
  width: 550px;
}

.width-155{
  width: 155px;
}

.input-data{
  width: 70px;
  text-align: right;
}

form {
  padding: 10px;
  color: #0009;
}

.b-layout {
  display: flex;
  justify-content: space-between;
}

input {
  margin-left: 100px;
}

.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.op {
  margin: 2%;
}
</style>